import { StockAvailabilityFilter } from "src/app/shared/model/grid-custom-filter.model";

export class StockFe {
    id: number = -1;
    stock_location_id: number = -1;
    item_id: number = -1;
    combination_id: number = -1;
    raw_material_id: number = -1;
    item_on_sale: boolean = false;
    stock_quantity: string = "";
    available = new StockAvailabilityFilter();
    unit: string = "";
    name: string = "";
    barcode: string = "";
    code: string = "";
    options_values: string | undefined = undefined;
    combination: string | undefined = undefined;
    lastupdate_at: Date = new Date();
    value: string = "";
    details: string = "";
}

export type StockFields = StockFe;

export type StockModuleSections = 'items-simple' | 'items-bom' | 'combinations' | 'raw-materials';
